import { render, staticRenderFns } from "./zatca-phase-2.vue?vue&type=template&id=b9249244"
import script from "./zatca-phase-2.vue?vue&type=script&lang=js"
export * from "./zatca-phase-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports